import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

/**
 * Download a set of assets as a branded zip.
 * Body accepts { ids, folder_id, category, name } — server enforces visibility.
 * Uses fetch (not axios) because axios' default timeout would kill big zips and
 * blob handling is cleaner with the native Fetch API.
 */
export async function downloadAssetsZip(payload) {
  const token = localStorage.getItem("apollo_token");
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/assets/zip`;
  const pending = toast.loading("Preparing your download…");
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: JSON.stringify(payload || {}),
    });
    if (!res.ok) {
      let detail = res.statusText;
      try {
        const j = await res.json();
        detail = formatApiError({ response: { data: j } });
      } catch { /* ignore parse errors */ }
      toast.error(detail || "Download failed", { id: pending });
      return false;
    }
    const disp = res.headers.get("content-disposition") || "";
    const match = disp.match(/filename="([^"]+)"/);
    const filename = match ? match[1] : "apollo-assets.zip";
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objUrl), 1500);
    toast.success(`Downloaded ${filename}`, { id: pending });
    return true;
  } catch (err) {
    toast.error(err?.message || "Download failed", { id: pending });
    return false;
  }
}
